var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const isFirefox = typeof window.InstallTrigger !== 'undefined';
const isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
const isChrome = !!window.chrome && !isOpera;
let screenCallback = null;
let sourceId = null;
let hasPlugin = false;
function getSourceId(callback) {
    if (!callback)
        throw '"callback" parameter is mandatory.';
    if (sourceId)
        return callback(sourceId);
    screenCallback = callback;
    window.postMessage('get-sourceId', '*');
}
window.addEventListener('message', function (event) {
    if (event.origin != window.location.origin) {
        return;
    }
    let data = event.data;
    if (data == 'PermissionDeniedError') {
        screenCallback('PermissionDeniedError');
    }
    if (data == 'PermissionCanceldError' && screenCallback) {
        screenCallback('PermissionCanceldError');
    }
    if (data == 'rtcmulticonnection-extension-loaded') {
        hasPlugin = true;
    }
    if (data.sourceId && screenCallback) {
        sourceId = data.sourceId;
        screenCallback(sourceId);
    }
});
window.postMessage('are-you-there', '*');
const getScreenStream = (mediaType) => {
    return new Promise((resolve, reject) => {
        let navMedia = navigator.mediaDevices;
        if (navMedia.getDisplayMedia) {
            let stream;
            (() => __awaiter(this, void 0, void 0, function* () {
                stream = yield navMedia.getDisplayMedia({ video: true }).catch((err) => {
                    if ('NotAllowedError' == err.name) {
                        resolve('user-Denied');
                    }
                });
                let video = document.createElement('video');
                video.setAttribute('autoplay', '');
                video.style.objectFit = "cover";
                video.style.width = "100%";
                video.style.height = "100%";
                video.srcObject = stream;
                let mediaRender = document.createElement('div');
                mediaRender.style.width = "100%";
                mediaRender.style.height = "100%";
                mediaRender.appendChild(video);
                video.addEventListener("loadedmetadata", function () {
                    if (this.videoWidth > this.videoHeight) {
                        video.style.objectFit = "cover";
                    }
                    resolve({
                        stream,
                        video,
                        mediaRender
                    });
                });
            }))();
        }
        else {
            if (isFirefox) {
                let userMediaType = 'screen';
                switch (mediaType) {
                    case 'window':
                    case 'application':
                        userMediaType = mediaType;
                }
                let stream;
                (() => __awaiter(this, void 0, void 0, function* () {
                    let videoConstraints = {
                        "mediaSource": userMediaType
                    };
                    stream = yield navigator.mediaDevices.getUserMedia({ video: videoConstraints });
                    let video = document.createElement('video');
                    video.setAttribute('autoplay', '');
                    video.style.width = "100%";
                    video.style.height = "100%";
                    video.srcObject = stream;
                    let mediaRender = document.createElement('div');
                    mediaRender.style.width = "100%";
                    mediaRender.style.height = "100%";
                    mediaRender.appendChild(video);
                    video.addEventListener("loadedmetadata", function () {
                        if (this.videoWidth > this.videoHeight) {
                            video.style.objectFit = "cover";
                        }
                        resolve({
                            stream,
                            video,
                            mediaRender
                        });
                    });
                }))();
            }
            else if (isChrome) {
                if (hasPlugin) {
                    let screen_constraints = {
                        mandatory: {
                            chromeMediaSource: 'screen',
                            maxWidth: screen.width > 1920 ? screen.width : 1920,
                            maxHeight: screen.height > 1080 ? screen.height : 1080,
                            maxFrameRate: 5
                        },
                        optional: []
                    };
                    sourceId = null;
                    getSourceId((sourceId) => {
                        if ('PermissionCanceldError' == sourceId) {
                            resolve('user-cancel');
                        }
                        else if ('PermissionDeniedError' == sourceId) {
                            resolve('user-Denied');
                        }
                        else {
                            screen_constraints.mandatory.chromeMediaSourceId = sourceId;
                            let stream;
                            (() => __awaiter(this, void 0, void 0, function* () {
                                stream = yield navigator.mediaDevices.getUserMedia({
                                    video: screen_constraints
                                });
                                let video = document.createElement('video');
                                video.setAttribute('autoplay', '');
                                video.style.objectFit = "cover";
                                video.style.width = "100%";
                                video.style.height = "100%";
                                video.srcObject = stream;
                                let mediaRender = document.createElement('div');
                                mediaRender.style.width = "100%";
                                mediaRender.style.height = "100%";
                                mediaRender.appendChild(video);
                                video.addEventListener("loadedmetadata", function () {
                                    if (this.videoWidth > this.videoHeight) {
                                        video.style.objectFit = "cover";
                                    }
                                    resolve({
                                        stream,
                                        video,
                                        mediaRender
                                    });
                                });
                            }))();
                        }
                    });
                }
                else {
                    resolve(`no-ready`);
                }
            }
            else {
                resolve(`no-support`);
            }
        }
    });
};
window.getScreenStream = getScreenStream;
export default getScreenStream;
